export default {
    userDetails: {
        cmsData: {},
        sdkConfig: {},
        existingCustomer: {
            isExist: false,
        },
        customerData: {},
        confirmIntentData: {},
        paidHealthQuote: {},
    },
    common: {
        loadingIndicator: {
            isLoading: false,
        },
    },
    session: {
        currentTheme: "DEFAULT",
    },
};
